(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["editorial-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ck-editorial-marquee')) {
    customElements.define('ck-editorial-marquee', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.controls = this.querySelector('.ck-editorial-motion-controls');
        this.toggle = this.querySelector('[data-motion-toggle]');
        this.paused = false;
        this.update = () => {
          const enabled = this.dataset.motionEnabled === 'true' && this.dataset.designMode !== 'true' && !this.motion.matches;
          this.dataset.animated = String(enabled);
          this.dataset.paused = String(this.paused);
          if (this.controls) this.controls.hidden = !enabled;
          if (this.toggle) {
            this.toggle.setAttribute('aria-pressed', String(this.paused));
            this.toggle.textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
          }
        };
        this.toggle?.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, options);
        this.motion.addEventListener('change', this.update, options);
        this.addEventListener('shopify:block:select', event => {
          this.paused = true;
          this.update();
          event.target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
        }, options);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  if (!customElements.get('ck-editorial-rail')) {
    customElements.define('ck-editorial-rail', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.ck-editorial-rail');
        if (!this.rail) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.update = () => {
          const end = this.rail.scrollWidth - this.rail.clientWidth;
          if (this.previous) this.previous.disabled = this.rail.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.rail.scrollLeft >= end - 2;
        };
        const move = direction => {
          const child = this.rail.firstElementChild;
          if (!child) return;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 16;
          this.rail.scrollBy({ left: direction * (child.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        };
        this.previous?.addEventListener('click', () => move(-1), options);
        this.next?.addEventListener('click', () => move(1), options);
        this.rail.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' }), options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.rail);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  if (!customElements.get('ck-editorial-form')) {
    customElements.define('ck-editorial-form', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const form = this.querySelector('form');
        if (!form) return;
        if (this.dataset.preview === 'true') {
          const showPreview = () => {
            if (!form.reportValidity()) return;
            const status = this.querySelector('[data-editorial-status]');
            status.textContent = this.dataset.previewMessage;
            status.hidden = false;
            const summary = this.querySelector('[data-editorial-summary]');
            if (summary) {
              const list = summary.querySelector('dl');
              list.replaceChildren();
              for (const control of form.querySelectorAll('input:not([type="hidden"]), select, textarea')) {
                if (!control.value || !control.labels?.length) continue;
                const group = document.createElement('div');
                const term = document.createElement('dt');
                const detail = document.createElement('dd');
                term.textContent = control.labels[0].textContent.trim();
                detail.textContent = control.value;
                group.append(term, detail);
                list.append(group);
              }
              summary.hidden = false;
            }
          };
          form.addEventListener('submit', event => { event.preventDefault(); event.stopImmediatePropagation(); showPreview(); }, { ...options, capture: true });
          this.querySelector('[data-editorial-submit]')?.addEventListener('click', showPreview, options);
          form.addEventListener('keydown', event => {
            if (event.key === 'Enter' && event.target.matches('input')) { event.preventDefault(); showPreview(); }
          }, options);
        }
        if (form.querySelector('[data-editorial-open-dialog]')) {
          const dialog = this.closest('dialog');
          if (dialog) requestAnimationFrame(() => document.querySelector(`[data-dialog-open="${CSS.escape(dialog.id)}"]`)?.click());
        }
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["page-video-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ck-video-frame')) {
    customElements.define(
      'ck-video-frame',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.closest('dialog');
          if (!this.dialog) return;
          this.onOpen = () => this.load();
          this.onClose = () => this.replaceChildren();
          this.dialog.addEventListener('ck:open', this.onOpen);
          this.dialog.addEventListener('close', this.onClose);
        }

        disconnectedCallback() {
          if (!this.dialog) return;
          this.dialog.removeEventListener('ck:open', this.onOpen);
          this.dialog.removeEventListener('close', this.onClose);
        }

        load() {
          if (!this.dataset.src || this.querySelector('iframe')) return;
          const iframe = document.createElement('iframe');
          iframe.src = this.dataset.src;
          iframe.title = this.dataset.title || '';
          iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
          iframe.allowFullscreen = true;
          iframe.referrerPolicy = 'strict-origin-when-cross-origin';
          this.append(iframe);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
